import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {PopupSessionService} from '../../providers/services/popup-session.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-link-popup-dialog',
  templateUrl: './link-popup-dialog.component.html',
  styleUrls: ['./link-popup-dialog.component.scss']
})
export class LinkPopupDialogComponent implements OnInit, OnDestroy {
  private readonly dialogName = 'link-popup-dialog-component';
  private isClosed = false;

  constructor(private router: Router, private popupSessionService: PopupSessionService, private translateService: TranslateService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  closeDialog() {
    this.isClosed = true;
    this.popupSessionService.setDismissedForSession(this.dialogName);
  }

  hasToBeShown(): boolean {
    const dismissedForSession = this.popupSessionService.hasBeenDismissedForSession(this.dialogName);
    const linkPopupEnabled = this.translateService.instant('link_popup_enabled');

    if (dismissedForSession || linkPopupEnabled !== 'true') {
      return false;
    }

    return !this.isClosed;
  }
}
